<template>
  <imgMerge msg="Welcome to Your Vue.js App"/>
</template>

<script>
import imgMerge from './components/imgMerge.vue'


export default {
  name: 'App',
  components: {
    imgMerge
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
